import { RitualCard } from '@/components/rituals/RitualCard';
import { useDueRituals } from './useDueRituals';

/**
 * The rituals of the day on their own, for Mon travail without the living
 * file (Thread flags off). With it, rituals are the first rows of the file.
 */
export const TodayRituals = ({ className = 'mb-5' }: { className?: string }) => {
  const { rituals, error, today, replaceOccurrence } = useDueRituals();
  if (!rituals?.length && !error) return null;
  return (
    <section aria-label="Rituels" className={className}>
      <h2 className="py-1.5 text-sm font-semibold text-domino-ink">Rituels</h2>
      <div className="mt-1 divide-y divide-domino-cardBorder overflow-hidden rounded-lg border border-domino-cardBorder bg-domino-white">
        {error && <p role="alert" className="px-3.5 py-3 text-sm text-domino-inkSoft">{error}</p>}
        {(rituals ?? []).map((entry) => (
          <RitualCard key={entry.ritual.id} entry={entry} today={today} onChange={(occurrence) => replaceOccurrence(entry.ritual.id, occurrence)} />
        ))}
      </div>
    </section>
  );
};
